
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import { mapActions, mapState } from "vuex";
export default {
name: "",
props: {
money: {
type: Number,
default: 0,
},
},
directives: {
TransferDom,
},
data() {
return {
show9: false,
guideList: [
"每位用户每天可进行一次答题拼图，限时180秒，四题全对即得红包，0.1~1元不等",
"超时或答错则本轮答题结束",
"每位用户每天可使用1张复活卡复活1次，复活卡需到医生汇APP积分商城兑换。",
"答对四题有机会获赠系统发放的友情红包，可转赠好友，每人每天最多领取3个好友红包",
"红包每满1元即可提现，提现前需先完善个人信息，提现以红包形式在医学V视界公众号发放",
"本活动最终解释权归北京医洋科技有限公司所有",
],
};
},
methods: {
...mapActions(["showCoverAction"]),
jump() {
sessionStorage.goBackUrl = location.href;
location.href = "/html/perfect.html#/perfect";
},
},
computed: {
...mapState({
popup: (state) => state.popup,
}),
},
components: {
XButton,
XDialog,
},
mounted() {},
};



// WEBPACK FOOTER //
// ./src/components/guideCover.vue